(() => {
  const header = document.querySelector('[data-header]');
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-menu]');
  const drawer = document.querySelector('[data-cart-drawer]');
  const openers = document.querySelectorAll('[data-cart-open]');
  const closer = document.querySelector('[data-cart-close]');

  const setHeader = () => {
    if (!header) return;
    header.classList.toggle('is-scrolled', window.scrollY > 24);
  };

  window.addEventListener('scroll', setHeader, { passive: true });
  setHeader();

  menuToggle?.addEventListener('click', () => {
    menu?.classList.toggle('is-open');
  });

  openers.forEach((opener) => {
    opener.addEventListener('click', (event) => {
      if (!drawer) return;
      event.preventDefault();
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
    });
  });

  closer?.addEventListener('click', () => {
    drawer?.classList.remove('is-open');
    drawer?.setAttribute('aria-hidden', 'true');
  });

  drawer?.addEventListener('click', (event) => {
    if (event.target === drawer) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    }
  });
})();
